<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <tailwind-image
            :link="require('@/assets/img/pc/cocos_4.jpg')"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                :link="require('@/assets/img/pc/cocos_5.jpg')"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                :link="require('@/assets/img/pc/cocos_6.jpg')"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            :link="require('@/assets/img/full/cocos_1.jpg')"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <span class="mt-5 w-full text-left">
            <p class="font-semibold">Entwurf</p>
            <p>Markus Holzbach mit Spacekitchen</p>
        </span>
    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {};
    },
    methods: {},
    created () { },
};
</script>